<template>
  <!--
    OS TORNEIOS, no papel — e sem código próprio de cartaz: o `TorneioCartaz` que o caderno usa é o
    mesmo daqui (D4: um primitivo, dois lugares). A versão antiga tinha 914 linhas duplicando o
    card inteiro com 🏆⏳🥇; esta lista os cartazes num modal e cuida só do relógio.
  -->
  <FishModal :aberto="true" :titulo="$t('competitions.title')" @fechar="$emit('close')">
    <p v-if="!competitions.length" class="torneios__quieto">{{ $t('competitions.noCompetitions') }}</p>

    <div v-else class="torneios__lista">
      <TorneioCartaz
        v-for="torneio in competitions"
        :key="torneio.id"
        :competition="torneio"
        :ranking="getCompetitionRanking(torneio.id) || []"
      />
    </div>
  </FishModal>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { FishModal } from '@/shared/ui';
import TorneioCartaz from '@/shared/inventory/TorneioCartaz.vue';

export default {
  name: 'CompetitionModal',
  components: { FishModal, TorneioCartaz },
  emits: ['close'],
  data() {
    return {
      updateInterval: null
    };
  },
  computed: {
    ...mapState('competition', ['competitions']),
    ...mapGetters('competition', ['getCompetitionRanking'])
  },
  methods: {
    ...mapActions('competition', ['fetchAllCompetitions', 'fetchCompetitionRanking']),
    async updateCompetitions() {
      await this.fetchAllCompetitions();
      for (const competition of this.competitions) {
        await this.fetchCompetitionRanking(competition.id);
      }
    }
  },
  async created() {
    await this.updateCompetitions();
    // O tempo restante anda enquanto o modal está aberto.
    this.updateInterval = setInterval(this.updateCompetitions, 60000);
  },
  beforeUnmount() {
    if (this.updateInterval) {
      clearInterval(this.updateInterval);
    }
  }
};
</script>

<style scoped>
.torneios__quieto {
  margin: 0;
  color: var(--tinta-fraca);
  font-style: italic;
  font-size: var(--f-1);
}

.torneios__lista {
  display: flex;
  flex-direction: column;
  gap: var(--e-3);
}
</style>
